import React from 'react';
import { t } from 'Src/i18n';
import { AlternativeSuggestionCriteria } from 'Components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria';
import { AlternativeSuggestions } from 'Components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions';
type Props = {
  className?: string;
  dates: ReadonlyArray<DateSuggestion>;
  onClose?: () => void;
  onSubmit: (args: any) => void;
  resort: Readonly<{
    image?: string;
    name: string;
  }>;
  trackingData: (arg0: string) => void;
};
export const AlternativeDateSuggestion = ({
  className,
  dates,
  onClose,
  onSubmit,
  resort,
  trackingData,
}: Props) => (
  <AlternativeSuggestions
    className={className}
    immersiveResort={resort}
    onClose={onClose}
    title={t('booking.counterProposalPopIn.weSuggestLabel', {
      resortName: resort.name,
    })}
  >
    {dates.map((suggestion) => (
      <AlternativeSuggestionCriteria
        buttonLabel={t('booking.counterProposalPopIn.checkPriceLabel')}
        key={suggestion.dateOffset}
        onSubmit={(newArrivalDate) => {
          onSubmit(newArrivalDate);
          trackingData('date_check');
        }}
        suggestion={suggestion}
      />
    ))}
  </AlternativeSuggestions>
);
